import { handleResponseError } from "./response-interceptors";

export class HttpClient {
  httpClient;
  constructor(
    httpClient,
    requestInterceptors = [],
    responseInterceptors = []
  ) {
    this.httpClient = httpClient;
    this.addRequestInterceptors(requestInterceptors);
    this.addResponseInterceptors(responseInterceptors);
  }

  addRequestInterceptors(requestInterceptors) {
    if (requestInterceptors.length > 0) {
      requestInterceptors.forEach((interceptor) => {
        this.httpClient.interceptors.request.use(
          (config) => interceptor(config),
          (error) => {
            return Promise.reject(error);
          }
        );
      });
    }
  }

  addResponseInterceptors(responseInterceptors) {
    if (responseInterceptors.length > 0) {
      responseInterceptors.forEach((interceptor) => {
        this.httpClient.interceptors.response.use(
          (config) => interceptor(config, this.httpClient),
          (error) => {
            return handleResponseError(
              this.getAxiosErrorDetails(error),
              this.httpClient
            );
          }
        );
      });
    }
  }

  async get(url, config) {
    try {
      const response = await this.httpClient.get(url, config);
      return response;
    } catch (error) {
      return this.getAxiosErrorDetails(error);
    }
  }

  async getFile(config) {
    try {
      const response = await this.httpClient(config);
      return response;
    } catch (error) {
      return this.getAxiosErrorDetails(error);
    }
  }

  async post(url, data, config) {
    try {
      const response = await this.httpClient.post(url, data, config);
      return response;
    } catch (error) {
      return this.getAxiosErrorDetails(error);
    }
  }

  async put(url, config) {
    const response = await this.httpClient.put(url, config);
    return response;
  }

  async delete(url, config) {
    const response = await this.httpClient.delete(url, config);
    return response;
  }

  async patch(url, config) {
    const response = await this.httpClient.patch(url, config);
    return response;
  }

  getAxiosErrorDetails(error) {
    let apiResponse;
    if (error.response) {
      apiResponse = {
        isSuccessful: false,
        status: error.response.status,
        errorMessage: error.response.statusText,
        config: error.response.config,
      };
    } else if (error.request) {
      apiResponse = {
        isSuccessful: false,
        status: 998,
        errorMessage: "No response recieved from server",
      };
    } else {
      apiResponse = {
        isSuccessful: false,
        status: 498, // custom error code
        errorMessage: "Client failed to send request",
      };
    }
    return apiResponse;
  }
}
